import { Injectable } from '@angular/core';

import { ActionResponseModel }     from './typings/workshop-web.action-response';
import { ActivationResponseModel } from './typings/workshop-web.activation-response';
import { ApiService }              from '../api/api.service';
import { CodeTypeModel }           from '../core/models/code-type';
import { EditorTokenModel }        from './typings/workshop-web.editor-token';
import { WorkshopWebStatusModel }  from './typings/workshop-web.status';

@Injectable({
  providedIn: 'root'
})
export class WorkshopWebService {
  constructor (
    private apiService : ApiService
  ) {}

  activate ( type : string ) : Promise<ActivationResponseModel> {
    return this.apiService.post('/mws/activate', {
      workshop_type: type
    });
  }

  deactivate () : Promise<ActionResponseModel> {
    return this.apiService.post('/mws/deactivate', {});
  }

  getEditorToken () : Promise<EditorTokenModel> {
    return this.apiService.get('/mws/edit');
  }

  getStatus () : Promise<WorkshopWebStatusModel> {
    return this.apiService.get('/mws/status');
  }

  getWorkshopTypes () : Promise<Array<CodeTypeModel>> {
    return this.apiService.get('/mws/mws_ws_types');
  }

  isEnrichmentDone ( event : MessageEvent ) : boolean {
    return event.data?.type === 'mws_enrichment_done';
  }

  reactivate () : Promise<ActionResponseModel> {
    return this.apiService.post('/mws/reactivate', {});
  }
}
